<template lang="pug">
  .b-spec-settings(data-testid="settings-dialog")
    ._title Настройки спецификации
    ._line
      ._label Комиссия дизайнера, %
      BaseInput._input(inputTestId="settings-commission" v-model="commission" :disabled="locked || readOnly")
      span._locked(v-if="locked" data-testid="settings-commission-locked") комиссия зафиксирована первым утверждением
    ._line(v-if="!locked && !readOnly")
      ._label Причина изменения
      BaseInput._input(inputTestId="settings-commission-reason" v-model="reason" label="необязательно")
    ._line
      ._label Имя заказчика
      BaseInput._input(inputTestId="settings-customer-name" v-model="customerName" :disabled="readOnly")
    ._line._link-line
      ._label Ссылка заказчика
      span._link(data-testid="settings-link") {{ link }}
      button._link-btn(type="button" data-testid="settings-link-copy" @click="copy") Скопировать
      button._link-btn(v-if="!readOnly" type="button" data-testid="settings-link-reissue" @click="reissue") Перевыпустить
    ._buttons
      Btn(v-if="!readOnly" blue data-testid="settings-save" @click="save") Сохранить
      Btn(grey data-testid="settings-close" @click="$emit('finish', false)") Закрыть
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import specificationApi from '@/api/specification';
import popup from '@/model/popup';
import { apiRun } from '@/model/apiRun';

/**
 * Окно «Настройки» спецификации (ТЗ 6.2): комиссия с необязательной причиной (после первого
 * утверждения заказчиком — только чтение с подсказкой), имя заказчика, персональная ссылка с
 * копированием и перевыпуском (перевыпуск необратим, поэтому с подтверждением, ТЗ 6.9).
 * Сгенерировано Claude.
 */
export default {
  name: 'SpecSettingsPopupWrappable',
  components: { BaseInput },
  data() {
    return {
      specification: null,
      readOnly: false,
      commission: '0',
      reason: '',
      customerName: '',
      link: '',
    };
  },
  computed: {
    locked() { return !!this.specification?.firstApprovedAt; },
  },
  methods: {
    init(params = {}) {
      this.specification = params.specification ?? null;
      this.readOnly = !!params.readOnly;
      this.commission = String(this.specification?.commissionPercent ?? '0');
      this.customerName = this.specification?.customerName ?? '';
      this.loadLink();
    },
    loadLink() {
      if (!this.specification) return;
      specificationApi.fetchCustomerLink(this.specification.id)
        .then((r) => { this.link = r.link; });
    },
    copy() {
      const { clipboard } = navigator;
      if (clipboard) clipboard.writeText(this.link);
    },
    async reissue() {
      const answer = await popup.addConfirm(
        'Перевыпустить ссылку заказчика?',
        'Старая ссылка перестанет работать.',
      );
      if (!answer) return;
      const result = await apiRun(
        () => specificationApi.reissueCustomerLink(this.specification.id),
        'Не удалось перевыпустить ссылку',
      );
      if (!result) return;
      this.link = result.link ?? this.link;
    },
    /** Комиссия после первого утверждения заказчиком — 422 с текстом от сервера (ТЗ 4.1, 6.9). */
    async save() {
      const params = { customerName: this.customerName.trim() };
      if (!this.locked) {
        params.commissionPercent = String(this.commission).replace(',', '.');
        if (this.reason.trim()) params.reason = this.reason.trim();
      }
      const specification = await apiRun(
        () => specificationApi.update(this.specification.id, params),
        'Не удалось сохранить настройки',
      );
      if (!specification) return;
      this.$emit('finish', specification);
    },
  },
};
</script>

<style scoped lang="scss">
.spec-settings {
  width: 620px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__line {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__label {
    width: 180px;
    font-size: 13px;
  }

  &__input {
    min-width: 220px;
  }

  &__locked {
    font-size: 11px;
    color: var(--color-middle-gray);
  }

  &__link {
    flex-basis: 100%;
    font-size: 11px;
    word-break: break-all;
    color: var(--color-middle-gray);
  }

  &__link-btn {
    border: none;
    background: none;
    font: inherit;
    font-size: 13px;
    color: var(--color-accent);
    cursor: pointer;
    padding: 0;
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
